import dotenv from 'dotenv';

// Load environment-specific .env file
if (process.env.NODE_ENV === 'development') {
  dotenv.config({ path: '.env.dev' });
} else {
  dotenv.config();
}

const isServer = typeof window === 'undefined';
// Determine if we're in local dev mode based on NODE_ENV
const isDevMode = process.env.NODE_ENV === 'development';

const databaseConfig = {
  development: {
    url: isServer ? (process.env.DATABASE_URL || 'postgres://william:Prometheus123@localhost:5432/prometheusdb') : undefined,
    dialect: 'postgres',
  },
  test: {
    url: isServer ? (process.env.TEST_DATABASE_URL || 'postgres://william:Prometheus123@localhost:5432/prometheusdb_test') : undefined,
    dialect: 'postgres',
  },
  production: {
    url: isServer ? process.env.DATABASE_URL : 'postgres://saprometheusadmin:s89xFJ630:a!@prometheus.postgres.database.azure.com:5432/postgres',
    dialect: 'postgres',
    dialectOptions: {
      ssl: {
        require: true,
        rejectUnauthorized: false
      }
    }
  }
};

const getEnvVar = (key, defaultValue = undefined) => {
  if (isServer) {
    return process.env[key] || defaultValue;
  }
  return defaultValue;
};

// Replace the dbConfig object with this:
export const dbConfig = {
    url: isServer ? (process.env.DATABASE_URL || 'postgres://saprometheusadmin:s89xFJ630:a!@prometheus.postgres.database.azure.com:5432/postgres') : undefined,
};

const envVars = {
    BING_API_KEY: getEnvVar('BING_API_KEY'),
    SERVER_URL: getEnvVar('SERVER_URL', isDevMode ? 'http://localhost:4000' : 'https://app1.prometheusmed.ai'),
    AZURE_TRANSLATOR_ENDPOINT: getEnvVar('AZURE_TRANSLATOR_ENDPOINT'),
    AZURE_TRANSLATOR_KEY: getEnvVar('AZURE_TRANSLATOR_KEY'),
    AZURE_TRANSLATOR_REGION: getEnvVar('AZURE_TRANSLATOR_REGION'),
    AZURE_B2C_CLIENT_ID: getEnvVar('AZURE_B2C_CLIENT_ID'),
    AZURE_B2C_TENANT_NAME: getEnvVar('AZURE_B2C_TENANT_NAME'),
    AZURE_B2C_TENANT_ID: getEnvVar('AZURE_B2C_TENANT_ID'),
    AZURE_B2C_SIGNUP_SIGNIN_POLICY_ID: getEnvVar('AZURE_B2C_SIGNUP_SIGNIN_POLICY_ID'),
    AZURE_B2C_AUTHORITY_DOMAIN: getEnvVar('AZURE_B2C_AUTHORITY_DOMAIN'),
    AZURE_B2C_AUTHORITY: getEnvVar('AZURE_B2C_AUTHORITY'),
    AZURE_B2C_REDIRECT_URI: getEnvVar('AZURE_B2C_REDIRECT_URI', isDevMode ? 'http://localhost:4000' : 'https://app1.prometheusmed.ai'),
    AZURE_B2C_LOGOUT_URI: getEnvVar('AZURE_B2C_LOGOUT_URI', isDevMode ? 'http://localhost:4000' : 'https://app1.prometheusmed.ai'),
    AZURE_B2C_SCOPES: getEnvVar('AZURE_B2C_SCOPES'),
    API_URI: getEnvVar('API_URI', isDevMode ? 'http://localhost:4000/api' : 'https://app1.prometheusmed.ai/api'),
    B2C_POLICY_SIGNUP_SIGNIN: getEnvVar('B2C_POLICY_SIGNUP_SIGNIN'),
    B2C_POLICY_RESET_PASSWORD: getEnvVar('B2C_POLICY_RESET_PASSWORD'),
    B2C_POLICY_EDIT_PROFILE: getEnvVar('B2C_POLICY_EDIT_PROFILE'),
    B2C_AUTHORITY_SIGNUP_SIGNIN: getEnvVar('B2C_AUTHORITY_SIGNUP_SIGNIN'),
    B2C_AUTHORITY_RESET_PASSWORD: getEnvVar('B2C_AUTHORITY_RESET_PASSWORD'),
    B2C_AUTHORITY_EDIT_PROFILE: getEnvVar('B2C_AUTHORITY_EDIT_PROFILE'),
    B2C_AUTHORITY_DOMAIN: getEnvVar('B2C_AUTHORITY_DOMAIN'),
    OPENAI_API_KEY: getEnvVar('OPENAI_API_KEY'),
    DATABASE_URL: getEnvVar('DATABASE_URL'),
// Add new LLM env vars
    LLM_PROVIDER: getEnvVar('LLM_PROVIDER', 'openai'), // Default to openai
    OPENROUTER_API_KEY: getEnvVar('OPENROUTER_API_KEY'),
    GROQ_API_KEY: getEnvVar('GROQ_API_KEY'),
    LLM_MODEL: getEnvVar('LLM_MODEL', 'gpt-4o-mini'), // Default model
    LLM_BASE_URL: getEnvVar('LLM_BASE_URL'), // Optional override for base URL
    OPENROUTER_REFERER: getEnvVar('OPENROUTER_REFERER'), // Optional for OpenRouter
    OPENROUTER_TITLE: getEnvVar('OPENROUTER_TITLE'), // Optional for OpenRouter,
    MAILGUN_API_KEY:getEnvVar('MAILGUN_API_KEY')

  };

// Remove or comment out this console.log
// console.log('Environment Variables:', envVars);

export const config = {
    OPENAI_API_KEY: isServer ? getEnvVar('OPENAI_API_KEY') : null,
    BING_API_KEY: getEnvVar('BING_API_KEY', '870dfd02286644fe96d62d23c771263f'),
    serverUrl: isServer ? envVars.SERVER_URL : window.location.origin,
    azureTranslatorEndpoint: envVars.AZURE_TRANSLATOR_ENDPOINT || 'https://api.cognitive.microsofttranslator.com/',
    azureTranslatorKey: envVars.AZURE_TRANSLATOR_KEY || '3d462a1b1e9042ea83d3b52518171547',
    azureTranslatorRegion: envVars.AZURE_TRANSLATOR_REGION || 'francecentral',
    azureB2C: {
        clientId: envVars.AZURE_B2C_CLIENT_ID || 'e165d727-efc4-451f-bfd5-cf710471a693',
        tenantName: envVars.AZURE_B2C_TENANT_NAME || 'prometheusaccess',
        tenantId: envVars.AZURE_B2C_TENANT_ID || 'https://prometheusaccess.onmicrosoft.com',
        signUpSignInPolicyId: envVars.AZURE_B2C_SIGNUP_SIGNIN_POLICY_ID || 'B2C_1_signup_signin_v2',
        authorityDomain: envVars.AZURE_B2C_AUTHORITY_DOMAIN || 'account.prometheusmed.ai',
        authority: envVars.AZURE_B2C_AUTHORITY || 'https://account.prometheusmed.ai/31a72539-2abe-4eb2-9c04-1cf276bdb333/B2C_1_signup_signin_v2',
        knownAuthorities: [envVars.AZURE_B2C_AUTHORITY_DOMAIN || 'account.prometheusmed.ai'],
        redirectUri: isServer ? envVars.AZURE_B2C_REDIRECT_URI : window.location.origin,
        postLogoutRedirectUri: isServer ? envVars.AZURE_B2C_LOGOUT_URI : window.location.origin,
        scopes: envVars.AZURE_B2C_SCOPES ? envVars.AZURE_B2C_SCOPES.split(',') : ['https://prometheusaccess.onmicrosoft.com/default/Prometheus.Access'],
        audience: envVars.AZURE_B2C_AUDIENCE,
    },
    apiConfig: {
        uri: envVars.API_URI || (isDevMode ? 'http://localhost:4000/api' : 'https://app1.prometheusmed.ai/api'),
    },
    b2cPolicies: {
        names: {
            signUpSignIn: envVars.B2C_POLICY_SIGNUP_SIGNIN || "B2C_1_signup_signin_v2",
            resetPassword: envVars.B2C_POLICY_RESET_PASSWORD || "B2C_1_password_reset",
            editProfile: envVars.B2C_POLICY_EDIT_PROFILE || "B2C_1_edit_profile"
        },
        authorities: {
            signUpSignIn: {
                authority: envVars.B2C_AUTHORITY_SIGNUP_SIGNIN || 'https://account.prometheusmed.ai/prometheusaccess.onmicrosoft.com/B2C_1_signup_signin_v2'
            },
            resetPassword: {
                authority: envVars.B2C_AUTHORITY_RESET_PASSWORD || 'https://account.prometheusmed.ai/prometheusaccess.onmicrosoft.com/B2C_1_password_reset'
            },
            editProfile: {
                authority: envVars.B2C_AUTHORITY_EDIT_PROFILE || 'https://account.prometheusmed.ai/prometheusaccess.onmicrosoft.com/B2C_1_edit_profile'
            }
        },
        authorityDomain: envVars.B2C_AUTHORITY_DOMAIN || "account.prometheusmed.ai"
    },
    database: isServer ? databaseConfig[process.env.NODE_ENV || 'development'] : undefined,
// Add the new llmConfig block here
    llmConfig: {
        provider: envVars.LLM_PROVIDER,
        model: envVars.LLM_MODEL,
        baseURL: envVars.LLM_BASE_URL, // Will be null if not set, handled by providers
        apiKey: {
            openai: envVars.OPENAI_API_KEY,
            openrouter: envVars.OPENROUTER_API_KEY,
            groq: envVars.GROQ_API_KEY,
        },
        // OpenRouter specific headers (optional)
        openRouterReferer: envVars.OPENROUTER_REFERER,
        openRouterTitle: envVars.OPENROUTER_TITLE,
    }
};


export const allowedSites = ['pubmed.ncbi.nlm.nih.gov','www.cdc.gov','embase.com','webofscience.com','cochranelibrary.com','scholar.google.com','scopus.com','clinicaltrials.gov','apa.org','ncbi.nlm.nih.gov','ebscohost.com','sciencedirect.com','uptodate.com','jstor.org','lexisnexis.com','pedro.org.au','ovid.com','otseeker.com','dynamed.com','lilacs.bvsalud.org','jbi.global','cabdirect.org','tripdatabase.com','nature.com','cell.org'];

// Export llmConfig here
export const { azureB2C, apiConfig, b2cPolicies, llmConfig } = config;
export default databaseConfig;
export const subscriptionConfig = {
  subscriptionTiers: {
    basic: {
      allowedSearches: {
        basic: { daily: 4 },
        advanced: { daily: 1 },
        professional: { daily: 0 }
      }
    },
    essential: {
      allowedSearches: {
        basic: { daily: 40 },
        advanced: { daily: 3 },
        professional: { daily: 0 }
      }
    },
    premium: {
      allowedSearches: {
        basic: { daily: 80 },
        advanced: { daily: 16 },
        professional: { daily: 20 }
      }
    },
    unlimited: {
      allowedSearches: {
        basic: { daily: Infinity },
        advanced: { daily: Infinity },
        professional: { daily: Infinity }
      }
    }
  },
  searchTypes: {
    basic: {
      maxSearchResults: 8,
      topResults: 5,
      maxTokens: 1000
    },
    advanced: {
      maxSearchResults: 20,
      topResults: 10,
      maxTokens: 1600
    },
    professional: {
      maxSearchResults: 50,
      topResults: 20,
      maxTokens: 3000
    }
  }
};